import axios from 'axios'
import {
    decryptBase64,
    decryptWithAes,
    encryptBase64,
    encryptWithAes,
    generateAesKey
} from '@/utils/encryption/crypto';
import * as encryptUtil from '@/utils/encryption/jsencrypt';
import {ElMessage} from 'element-plus'
import router from '@/router'


// 创建axios实例
const service = axios.create({
    baseURL: import.meta.env.VITE_GLOB_API_URL || '/api', // 使用环境变量或代理
    timeout: 15000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(config => { // 在请求发送之前做一些处理
    const token = localStorage.getItem('access_token')
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }

    let clientId = import.meta.env.VITE_GLOB_APP_CLIENT_ID || '';
    if (window.innerWidth < 768) {
        clientId = import.meta.env.VITE_GLOB_APP_CLIENT_ID_MOBILE || '';
    }
    config.headers.ClientID = clientId;

    // 对POST/PUT请求的data加密
    if (config.encrypt && config.method === 'post' || config.method === 'put') {
        const aesKey = generateAesKey();
        console.log('aesKey:', aesKey);

        config.headers['encrypt-key'] = encryptUtil.encrypt(encryptBase64(aesKey),);

        config.data = typeof config.data === 'object' ? encryptWithAes(JSON.stringify(config.data), aesKey) : encryptWithAes(config.data, aesKey);
    }

    // 对GET请求的params加密
    // if (config.method === 'get' && config.params && typeof config.params === 'object') {
    // config.params = {
    //     encrypted: encrypt(config.params)
    // }
    // }

    return config
}, error => { // 处理请求错误
    console.log(error)
    return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(response => {
    const res = response.data
    // 弹出msg弹窗
    if (res && res.msg && res.code !== 200) {

        ElMessage({
            message: res.msg,
            type: res.code === 200 || res.code === 0 ? 'success' : 'error',
            duration: 2000
        });

    }
    // 根据自定义错误码处理错误
    if (res.code !== 200 && res.code !== 0) {
        console.error('Request Error:', res.message || 'Unknown Error')

        // 401: 未登录或token过期
        if (res.code === 401) { // 可以在这里处理登出逻辑
            router.push({name: 'Login'})
        }
        return Promise.reject(new Error(res.message || 'Error'))
    } else {
        return res
    }


}, error => {
    console.error('Request Error:', error.message)
    return Promise.reject(error)
})

export default service
